export function needsSasSignature(url: string): boolean {
  return false; // por ahora siempre falso
}

export function getReadUrl(url: string): string {
  return url; // devuelve la misma URL
}
